export const FONT_VARIATION_PROPERTIES = [
  { name: 'Weight', value: 'wght' },
  { name: 'Width', value: 'wdth' },
  { name: 'Optical Size', value: 'opsz' },
  { name: 'Italic', value: 'ital' },
  { name: 'Slant', value: 'slnt' },
  { name: 'Grade', value: 'GRAD' },
  { name: 'X-Height', value: 'XHGT' },
  { name: 'Ascender Height', value: 'YTAS' },
  { name: 'Descender Depth', value: 'YTDE' },
  { name: 'Contrast', value: 'CNTR' },
  { name: 'Serif Height', value: 'SERF' },
  { name: 'Casual', value: 'CASL' },
  { name: 'Monospace', value: 'MONO' },
  { name: 'Softness', value: 'SOFT' },
  { name: 'Wonky', value: 'WONK' },
  { name: 'Hyper Expansion', value: 'HEXP' },
];

export const FONT_FEATURE_PROPERTIES = [
  { name: 'Standard Ligatures', value: 'liga' },
  { name: 'Discretionary Ligatures', value: 'dlig' },
  { name: 'Historical Ligatures', value: 'hlig' },
  { name: 'Contextual Ligatures', value: 'clig' },
  { name: 'Kerning', value: 'kern' },
  { name: 'Tabular Numbers', value: 'tnum' },
  { name: 'Old-style Numbers', value: 'onum' },
  { name: 'Lining Numbers', value: 'lnum' },
  { name: 'Proportional Numbers', value: 'pnum' },
  { name: 'Fractions', value: 'frac' },
  { name: 'Ordinals', value: 'ordn' },
  { name: 'Small Caps', value: 'smcp' },
  { name: 'Capitals to small caps', value: 'c2sc' },
  { name: 'Stylistic Alternates', value: 'salt' },
  { name: 'Contextual Alternates', value: 'calt' },
  { name: 'Swashes', value: 'swsh' },
  { name: 'Stylistic Sets', value: 'ss' },
];

export function is_stylistic_set(prop) {
  return /^ss\d{2}$/.test(prop);
}